<script>
    import {Icon} from 'svelma';

    export let toggleFunction;

    let infoHovered;
</script>

<div class="has-text-primary-dark info"
     class:opacityUp={infoHovered}
     on:mouseenter={()=>infoHovered=true}
     on:mouseleave={()=>infoHovered=false}
     on:click={toggleFunction()}>
    <Icon pack="fa" size="is-medium" icon="info-circle"/>
</div>

<style>
    .info {opacity: 0.3;}
    .info:hover {cursor: pointer;}
    .opacityUp {opacity: 1 !important;}
</style>